// Nepal Administrative Divisions Data
// 7 Provinces, 77 Districts, and Major Municipalities

export const NEPAL_LOCATIONS = {
  "Koshi Province": {
    districts: {
      "Bhojpur": ["Bhojpur Municipality", "Shadanand Municipality", "Hatuwagadhi Rural Municipality", "Ramprasad Rai Rural Municipality"],
      "Dhankuta": ["Dhankuta Municipality", "Pakhribas Municipality", "Mahalaxmi Municipality", "Sangurigadhi Rural Municipality"],
      "Ilam": ["Ilam Municipality", "Mai Municipality", "Deumai Municipality", "Suryodaya Municipality"],
      "Jhapa": ["Mechinagar Municipality", "Damak Municipality", "Kankai Municipality", "Bhadrapur Municipality", "Arjundhara Municipality"],
      "Khotang": ["Diktel Rupakot Majhuwagadhi Municipality", "Halesi Tuwachung Municipality", "Jantedhunga Rural Municipality"],
      "Morang": ["Biratnagar Metropolitan City", "Urlabari Municipality", "Belbari Municipality", "Letang Municipality", "Sundarharaicha Municipality"],
      "Okhaldhunga": ["Siddhicharan Municipality", "Champadevi Rural Municipality", "Sunkoshi Rural Municipality"],
      "Panchthar": ["Phidim Municipality", "Hilihang Rural Municipality", "Yangwarak Rural Municipality"],
      "Sankhuwasabha": ["Chainpur Municipality", "Dharmadevi Municipality", "Khandbari Municipality"],
      "Solukhumbu": ["Solududhkunda Municipality", "Mahakulung Rural Municipality", "Likhu Pike Rural Municipality"],
      "Sunsari": ["Dharan Sub-Metropolitan City", "Itahari Sub-Metropolitan City", "Inaruwa Municipality", "Duhabi Municipality"],
      "Taplejung": ["Phungling Municipality", "Sidingba Rural Municipality", "Mikwakhola Rural Municipality"],
      "Terhathum": ["Myanglung Municipality", "Laligurans Municipality", "Chhathar Rural Municipality"],
      "Udayapur": ["Triyuga Municipality", "Katari Municipality", "Chaudandigadhi Municipality", "Belaka Municipality"]
    }
  },
  "Madhesh Province": {
    districts: {
      "Bara": ["Kalaiya Sub-Metropolitan City", "Jeetpur Simara Sub-Metropolitan City", "Kolhabi Municipality", "Nijgadh Municipality"],
      "Dhanusha": ["Janakpurdham Sub-Metropolitan City", "Chhireshwarnath Municipality", "Ganeshman Charnath Municipality", "Mithila Municipality"],
      "Mahottari": ["Jaleshwar Municipality", "Bardibas Municipality", "Gaushala Municipality", "Loharpatti Municipality"],
      "Parsa": ["Birgunj Metropolitan City", "Pokhariya Municipality", "Parsagadhi Municipality", "Bahudarmai Municipality"],
      "Rautahat": ["Gaur Municipality", "Chandrapur Municipality", "Gujara Municipality", "Dewahi Gonahi Municipality"],
      "Saptari": ["Rajbiraj Municipality", "Bodebarsain Municipality", "Dakneshwori Municipality", "Hanumannagar Kankalini Municipality"],
      "Sarlahi": ["Ishworpur Municipality", "Malangwa Municipality", "Lalbandi Municipality", "Haripur Municipality"],
      "Siraha": ["Lahan Municipality", "Dhangadhimai Municipality", "Siraha Municipality", "Golbazar Municipality"]
    }
  },
  "Bagmati Province": {
    districts: {
      "Bhaktapur": ["Bhaktapur Municipality", "Changunarayan Municipality", "Madhyapur Thimi Municipality", "Suryabinayak Municipality"],
      "Chitwan": ["Bharatpur Metropolitan City", "Ratnanagar Municipality", "Rapti Municipality", "Kalika Municipality"],
      "Dhading": ["Dhunibeshi Municipality", "Nilakantha Municipality", "Khanikhola Rural Municipality", "Gajuri Rural Municipality"],
      "Dolakha": ["Bhimeshwor Municipality", "Jiri Municipality", "Kalinchok Rural Municipality", "Gaurishankar Rural Municipality"],
      "Kathmandu": ["Kathmandu Metropolitan City", "Kageshwori Manahara Municipality", "Kirtipur Municipality", "Shankharapur Municipality", "Budhanilkantha Municipality"],
      "Kavrepalanchok": ["Dhulikhel Municipality", "Banepa Municipality", "Panauti Municipality", "Namobuddha Municipality", "Mandandeupur Municipality"],
      "Lalitpur": ["Lalitpur Metropolitan City", "Godawari Municipality", "Mahalaxmi Municipality", "Bagmati Rural Municipality"],
      "Makwanpur": ["Hetauda Sub-Metropolitan City", "Thaha Municipality", "Indrasarowar Rural Municipality", "Bhimphedi Rural Municipality"],
      "Nuwakot": ["Bidur Municipality", "Belkotgadhi Municipality", "Kakani Rural Municipality", "Tadi Rural Municipality"],
      "Ramechhap": ["Manthali Municipality", "Ramechhap Municipality", "Umakunda Rural Municipality", "Likhu Rural Municipality"],
      "Rasuwa": ["Uttargaya Rural Municipality", "Kalika Rural Municipality", "Gosaikunda Rural Municipality"],
      "Sindhuli": ["Kamalamai Municipality", "Dudhouli Municipality", "Sunkoshi Rural Municipality", "Golanjor Rural Municipality"],
      "Sindhupalchok": ["Chautara Sangachokgadhi Municipality", "Melamchi Municipality", "Barhabise Municipality", "Jugal Rural Municipality"]
    }
  },
  "Gandaki Province": {
    districts: {
      "Baglung": ["Baglung Municipality", "Galkot Municipality", "Jaimuni Municipality", "Dhorpatan Municipality"],
      "Gorkha": ["Gorkha Municipality", "Palungtar Municipality", "Sulikot Rural Municipality", "Gandaki Rural Municipality"],
      "Kaski": ["Pokhara Metropolitan City", "Annapurna Rural Municipality", "Machhapuchchhre Rural Municipality", "Madi Rural Municipality"],
      "Lamjung": ["Besishahar Municipality", "Rainas Municipality", "Sundarbazar Municipality", "Kwholasothar Rural Municipality"],
      "Manang": ["Chame Rural Municipality", "Nason Rural Municipality", "Narpa Bhumi Rural Municipality", "Manang Ngisyang Rural Municipality"],
      "Mustang": ["Gharpajhong Rural Municipality", "Thasang Rural Municipality", "Baragung Muktikshetra Rural Municipality", "Lomanthang Rural Municipality"],
      "Myagdi": ["Beni Municipality", "Annapurna Rural Municipality", "Dhaulagiri Rural Municipality", "Mangala Rural Municipality"],
      "Nawalpur": ["Kawasoti Municipality", "Gaindakot Municipality", "Devchuli Municipality", "Madhyabindu Municipality"],
      "Parbat": ["Kusma Municipality", "Phalebas Municipality", "Jaljala Rural Municipality", "Paiyun Rural Municipality"],
      "Syangja": ["Galyang Municipality", "Chapakot Municipality", "Putalibazar Municipality", "Waling Municipality"],
      "Tanahun": ["Bhanu Municipality", "Bhimad Municipality", "Byas Municipality", "Shuklagandaki Municipality"]
    }
  },
  "Lumbini Province": {
    districts: {
      "Arghakhanchi": ["Sandhikharka Municipality", "Sitganga Municipality", "Bhumikasthan Municipality", "Panini Rural Municipality"],
      "Banke": ["Nepalgunj Sub-Metropolitan City", "Kohalpur Municipality", "Rapti Sonari Rural Municipality", "Narainapur Rural Municipality"],
      "Bardiya": ["Gulariya Municipality", "Madhuwan Municipality", "Rajapur Municipality", "Thakurbaba Municipality"],
      "Dang": ["Tulsipur Sub-Metropolitan City", "Ghorahi Sub-Metropolitan City", "Lamahi Municipality", "Gadhawa Rural Municipality"],
      "Gulmi": ["Musikot Municipality", "Resunga Municipality", "Isma Rural Municipality", "Madane Rural Municipality"],
      "Kapilvastu": ["Kapilvastu Municipality", "Banganga Municipality", "Buddhabhumi Municipality", "Shivaraj Municipality"],
      "Nawalparasi (West)": ["Ramgram Municipality", "Palhi Nandan Municipality", "Sunwal Municipality", "Pratappur Rural Municipality"],
      "Palpa": ["Tansen Municipality", "Rampur Municipality", "Rainadevi Chhahara Rural Municipality", "Ribdikot Rural Municipality"],
      "Pyuthan": ["Pyuthan Municipality", "Swargadwari Municipality", "Gaumukhi Rural Municipality", "Jhimruk Rural Municipality"],
      "Rolpa": ["Rolpa Municipality", "Runtigadhi Rural Municipality", "Triveni Rural Municipality", "Sunchhahari Rural Municipality"],
      "Rukum (West)": ["Musikot Municipality", "Chaurjahari Municipality", "Aathbiskot Municipality", "Banphikot Rural Municipality"],
      "Rupandehi": ["Butwal Sub-Metropolitan City", "Siddharthanagar Municipality", "Tilottama Municipality", "Devdaha Municipality", "Lumbini Sanskritik Municipality"]
    }
  },
  "Karnali Province": {
    districts: {
      "Dailekh": ["Narayan Municipality", "Dullu Municipality", "Chamunda Bindrasaini Municipality", "Aathabis Municipality"],
      "Dolpa": ["Thuli Bheri Municipality", "Tripurasundari Municipality", "Dolpo Buddha Rural Municipality", "She Phoksundo Rural Municipality"],
      "Humla": ["Simkot Rural Municipality", "Namkha Rural Municipality", "Kharpunath Rural Municipality", "Sarkegad Rural Municipality"],
      "Jajarkot": ["Bheri Municipality", "Chhedagad Municipality", "Nalgad Municipality", "Barekot Rural Municipality"],
      "Jumla": ["Chandannath Municipality", "Kankasundari Rural Municipality", "Sinja Rural Municipality", "Hima Rural Municipality"],
      "Kalikot": ["Khandachakra Municipality", "Raskot Municipality", "Tilagufa Municipality", "Pachaljharana Rural Municipality"],
      "Mugu": ["Chhayanath Rara Municipality", "Mugum Karmarong Rural Municipality", "Soru Rural Municipality", "Khatyad Rural Municipality"],
      "Salyan": ["Shaarda Municipality", "Bagchaur Municipality", "Bangad Kupinde Municipality", "Kalimati Rural Municipality"],
      "Surkhet": ["Birendranagar Municipality", "Bheriganga Municipality", "Gurbhakot Municipality", "Panchpuri Municipality"]
    }
  },
  "Sudurpashchim Province": {
    districts: {
      "Achham": ["Mangalsen Municipality", "Sanphebagar Municipality", "Kamalbazar Municipality", "Panchadewal Binayak Municipality"],
      "Baitadi": ["Dasharathchand Municipality", "Patan Municipality", "Melauli Municipality", "Purchaudi Municipality"],
      "Bajhang": ["Jaya Prithvi Municipality", "Bungal Municipality", "Talkot Rural Municipality", "Masta Rural Municipality"],
      "Bajura": ["Badimalika Municipality", "Triveni Municipality", "Budhiganga Municipality", "Budhinanda Municipality"],
      "Dadeldhura": ["Amargadhi Municipality", "Parashuram Municipality", "Aalitaal Rural Municipality", "Bhageshwar Rural Municipality"],
      "Darchula": ["Shailyashikhar Municipality", "Mahakali Municipality", "Malikarjun Rural Municipality", "Apihimal Rural Municipality"],
      "Doti": ["Dipayal Silgadhi Municipality", "Shikhar Municipality", "Purbichauki Rural Municipality", "Jorayal Rural Municipality"],
      "Kailali": ["Dhangadhi Sub-Metropolitan City", "Tikapur Municipality", "Ghodaghodi Municipality", "Lamkichuha Municipality", "Bhajani Municipality"],
      "Kanchanpur": ["Bhimdatta Municipality", "Punarbas Municipality", "Bedkot Municipality", "Mahakali Municipality", "Shuklaphanta Municipality"]
    }
  }
};

// Get list of all provinces
export const getProvinces = () => {
  return Object.keys(NEPAL_LOCATIONS);
};

// Get districts for a specific province
export const getDistricts = (province) => {
  if (!province || !NEPAL_LOCATIONS[province]) {
    return [];
  }
  return Object.keys(NEPAL_LOCATIONS[province].districts);
};

// Get all districts from all provinces (flat list, sorted alphabetically)
export const getAllDistricts = () => {
  const allDistricts = [];
  const provinces = Object.keys(NEPAL_LOCATIONS);

  provinces.forEach(province => {
    const districts = Object.keys(NEPAL_LOCATIONS[province].districts);
    allDistricts.push(...districts);
  });

  // Sort alphabetically and return
  return allDistricts.sort();
};

// Get municipalities for a specific district
export const getMunicipalities = (province, district) => {
  if (!province || !district || !NEPAL_LOCATIONS[province] || !NEPAL_LOCATIONS[province].districts[district]) {
    return [];
  }
  return NEPAL_LOCATIONS[province].districts[district];
};
